(function () {
    'use strict';

    function adminEntityConfigurationDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/adminentityconfigurations';

        function loadSummaries() {
            return $http.get('[BuildifyApiHost]/api/adminentityconfigurationsummaries').then(function (response) {
                return response.data;
            });
        };

        function loadAll() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        };

        function load(id) {
            return $http.get(baseUrl + '/' + id).then(function (response) {
                return response.data;
            });
        };

        function save(id, data) {
            return $http.put(baseUrl + '/' + id, data).then(
                function (response) { return true; }
            );
        };

        return {
            loadSummaries: loadSummaries,
            loadAll: loadAll,
            load: load,
            save: save
        };
    }

    adminEntityConfigurationDataService.$inject = ['$http'];

    angular.module('ecap.siteConfiguration').service('adminEntityConfigurationDataService', adminEntityConfigurationDataService);
})();
